import { jsx as _jsx } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import React from "react";
import { styled } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import { ESlateSelectionStatus } from "../../services/SlateSelection";
var StatusLine = styled("p")(function (_a) {
    var _b;
    var theme = _a.theme;
    return (_b = {
            "margin": "8px 0 0",
            "fontSize": "13px",
            "fontWeight": 600,
            "lineHeight": 1.5,
            "color": theme.palette.brandColor,
            "&.slate-selection-status-all": {
                color: "#047857",
            }
        },
        _b[theme.breakpoints.down("sm")] = {
            fontSize: "12px",
        },
        _b);
});
export var SlateSelectionStatus = function (_a) {
    var summary = _a.summary;
    var t = useTranslation().t;
    if (summary.status === ESlateSelectionStatus.NONE) {
        return null;
    }
    return (_jsx(StatusLine, { className: "slate-selection-status slate-selection-status-".concat(summary.status), children: t("slates.selection.".concat(summary.status), {
            selected: summary.selected,
            total: summary.total,
        }) }));
};
